import { del, get, post, put } from './request'

interface MeetingRooms {
    supplier: string;
    propertyId: string;
    property: {
        meetingrooms: object
    };
}


export const getMeetingRooms = (supplier: string, propertyid: string) => get(`/property/meetingrooms?supplier=${supplier}&propertyid=${propertyid}`)

/*
    All the below APIs are for adding, updating and deleting  the invidual sub-categories. All of them will return the same response as the GET api response.
*/

export const saveOrUpdateMeetingRooms = (meetingRooms: MeetingRooms) => post('/property/meetingrooms', meetingRooms)  // General save
export const saveOrUpdateMeetingRoomsExtraFacility = (meetingRooms: MeetingRooms) => post('/property/meetingrooms/extrafacility', meetingRooms)
export const saveOrUpdateMeetingRoomsRates = (meetingRooms: MeetingRooms) => post('/property/meetingrooms/rates', meetingRooms)
export const saveOrUpdateMeetingRoomsPayment = (meetingRooms: MeetingRooms) => post('/property/meetingrooms/payment', meetingRooms)

export const addMeetingRoom = (meetingRooms: MeetingRooms) => post('/property/meetingrooms/meetingroom', meetingRooms)
export const updateMeetingRoom = (meetingRooms: MeetingRooms) => put('/property/meetingrooms/meetingroom', meetingRooms)
export const deleteMeetingRoom = (meetingRooms: MeetingRooms) => del('/property/meetingrooms/meetingroom', meetingRooms)

export const addMeetingRoomCapacity = (meetingRooms: MeetingRooms) => post('/property/meetingrooms/meetingroom/capacity', meetingRooms)
export const updateMeetingRoomCapacity = (meetingRooms: MeetingRooms) => put('/property/meetingrooms/meetingroom/capacity', meetingRooms)
export const deleteMeetingRoomCapacity = (meetingRooms: MeetingRooms) => del('/property/meetingrooms/meetingroom/capacity', meetingRooms)

export const addMeetingRoomService = (meetingRooms: MeetingRooms) => post('/property/meetingrooms/meetingroom/service', meetingRooms)
export const updateMeetingRoomService = (meetingRooms: MeetingRooms) => put('/property/meetingrooms/meetingroom/service', meetingRooms)
export const deleteMeetingRoomService = (meetingRooms: MeetingRooms) => del('/property/meetingrooms/meetingroom/service', meetingRooms)




